import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Pagination from '../../Common/Pagination';
import Matches from '../../Common/Matches';
import Results from '../../Common/Results';

/**
 * Profiles list presentational component
 * Displays list of fetched profile types with pagination.
 * Displays spinner while fetching.
 */
export default class ProfilesList extends PureComponent {
    static propTypes = {
        /**
         * Selected profiles type label
         */
        title: PropTypes.string.isRequired,
        /**
         * True while application is fetching profiles from server
         */
        fetching: PropTypes.bool.isRequired,
        /**
         * True if last profiles fetching has failed
         */
        fetchFailed: PropTypes.bool.isRequired,
        /**
         * Array of fetched profiles
         */
        items: PropTypes.arrayOf(PropTypes.object).isRequired,
        /**
         * Overall number of available profiles by type
         */
        itemsNum: PropTypes.number.isRequired,
        /**
         * Current profiles page
         */
        page: PropTypes.number.isRequired,
        /**
         * Overall number of available profiles pages
         */
        pagesNum: PropTypes.number.isRequired,
        /**
         * Function to render profile
         */
        itemRenderer: PropTypes.func.isRequired,
        /**
         * Function to handle click on matches link
         */
        onGoBack: PropTypes.func.isRequired,
        /**
         * Function to handle change of profiles page
         */
        onPageChange: PropTypes.func.isRequired,
    }

    handleMatchesLinkClick = (e) => {
        e.preventDefault();
        this.props.onGoBack();
    }

    render() {
        const {
            title,
            fetching,
            fetchFailed,
            items,
            itemsNum,
            page,
            pagesNum,
            onPageChange,
        } = this.props;
        return (
            <div>
                <h2 className="search-resultHeader">
                    <a
                        href="#go_back"
                        className="ui-link_primary"
                        onClick={this.handleMatchesLinkClick}
                    >
                        Matches
                    </a> - <span>{title}</span> <Matches itemsNum={itemsNum} />
                </h2>
                <Results
                    itemsNum={itemsNum}
                    fetching={fetching}
                    error={fetchFailed}
                >
                    <ul className="search-resultList">
                        {items.map(this.props.itemRenderer)}
                    </ul>
                </Results>
                <Pagination
                    totalPagesNum={pagesNum}
                    displayedPagesNum={5}
                    page={page}
                    onPageChange={onPageChange}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/Profiles/components/ProfilesList.jsx